export default "__VITE_ASSET___ohd378a__"